import {
  FETCH_WALLET_REQUEST,
  FETCH_WALLET_SUCCESS,
  FETCH_WALLET_FAILURE,
} from "../actions/UserActions";

const initialState = {
  walletDetails: {},
  walletAmount: 0,
  isLoading: false,
  error: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_WALLET_SUCCESS:
      return {
        ...state,
        walletDetails: action.payload,
        walletAmount: action.payload.amount,
        isLoading: false,
      };

    case FETCH_WALLET_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    default:
      return state;
  }
};
